/**
 * Merge a saved preference list with local UI picks.
 * Used when the user can click before profile hydrate — keep both so a save
 * cannot wipe Firestore prefs that never made it into local state.
 */
export function unionStringLists(saved: string[] | null | undefined, local: string[]): string[] {
  const fromSaved = Array.isArray(saved)
    ? saved.filter((v): v is string => typeof v === 'string' && !!v)
    : [];
  if (local.length === 0) return [...fromSaved];
  if (fromSaved.length === 0) return [...local];
  return Array.from(new Set([...fromSaved, ...local]));
}
